import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { Container, Col, Row, Button } from 'react-bootstrap'
import FilterNoneIcon from '@material-ui/icons/FilterNone'

class ReportePbiMermasYCalidad extends Component {
  copiarPortapapeles () {
    const link = 'https://app.powerbi.com/view?r=eyJrIjoiZTQ3M2VhNTEtNDRlYS00ZDNmLThmMWYtNWFlZjAyNjRjNGQ0IiwidCI6IjllNmNmYjVlLTQ1YWUtNDMxOS1hZjQwLWE1MTg3ZjIwYTVjZSIsImMiOjR9'
    navigator.clipboard.writeText(link)
  }

  render () {
    return (
      <Container fluid>
        <Row>
          <Col md={10}>
            <h3>Mermas y Calidad</h3>
          </Col>
          <Col md={2}>
            <Button variant='light' size='sm' style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: '100%', justifyContent: 'center', outline: 'none' }} onClick={this.copiarPortapapeles}>
              <FilterNoneIcon fontSize='small' color='white' />
              <p style={{ margin: '0 0 0 2% ', fontSize: '0.8rem' }}>Copiar link</p>
            </Button>
          </Col>
        </Row>
        <Row style={{ marginTop: '2%' }}>
          <br />
          <div style={{ width: '98%' }}>

            <iframe title='Mermas y Calidad' style={{ width: '100%', height: '75vh' }}
              src='https://app.powerbi.com/view?r=eyJrIjoiZTQ3M2VhNTEtNDRlYS00ZDNmLThmMWYtNWFlZjAyNjRjNGQ0IiwidCI6IjllNmNmYjVlLTQ1YWUtNDMxOS1hZjQwLWE1MTg3ZjIwYTVjZSIsImMiOjR9' frameborder='0' allowFullScreen='true' />
          </div>
        </Row>
      </Container>
    )
  }
}
export default withRouter(ReportePbiMermasYCalidad)
